import React, { useState, useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import {
  Row, Col, Card, CardBody, CardTitle, CardHeader,
} from "reactstrap";
import {
  Table, Thead, Tbody, Tr, Th, Td,
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import { withTranslation } from "react-i18next";
import CustomPagination from "components/Common/CustomPagination";
import TableLoader from "components/Common/TableLoader";
import formatDate from "helpers/formatDate";
import { fetchEvents } from "store/events/actions";

function ClientEvents(props) {
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);

  const columns = [
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (val) => formatDate(val.createdAt, "DD/MM/YYYY"),
    },
    {
      dataField: "eventName",
      text: props.t("Event"),
    },
    {
      dataField: "city",
      text: props.t("City"),
      formatter: (val) => val.answers?.city || "-",
    },
    {
      dataField: "country",
      text: props.t("Country"),
      formatter: (val) => val.answers?.country || "-",
    },
    {
      dataField: "source",
      text: props.t("Source"),
    },
  ];

  const fetchData = (page) => {
    dispatch(fetchEvents({
      page: page || 1,
      limit: sizePerPage,
      customerId: props.clientId,
    }));
  };

  useEffect(() => {
    fetchData(1);
  }, [sizePerPage]);

  return (
    <div className="container-fluid">
      <Row>
        <Col className="col-12">
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
              <CardTitle className="color-primary">{props.t("Events")}</CardTitle>
            </CardHeader>
            <CardBody>
              <div className="table-rep-plugin">
                <div className="table-responsive mb-0" data-pattern="priority-columns">
                  <Table id="client-events-table" className="table table-hover">
                    <Thead className="text-center table-light">
                      <Tr>
                        {columns.map((column, index) => (
                          <Th data-priority={index} key={index}>
                            <span className="color-primary">{column.text}</span>
                          </Th>
                        ))}
                      </Tr>
                    </Thead>
                    <Tbody className="text-center">
                      {props.loading && <TableLoader colSpan={columns.length} />}
                      {!props.loading && props.events.length === 0 && (
                        <Tr>
                          <Td colSpan="100%" className="fw-bolder text-center">
                            <h3 className="fw-bolder text-center">{props.t("No records")}</h3>
                          </Td>
                        </Tr>
                      )}
                      {!props.loading && props.events.map((row, rowIndex) => (
                        <Tr key={rowIndex}>
                          {columns.map((column, index) => (
                            <Td key={`${rowIndex}-${index}`}>
                              {column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                            </Td>
                          ))}
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                  <CustomPagination
                    {...props.pagination}
                    docs={props.events}
                    setSizePerPage={setSizePerPage}
                    sizePerPage={sizePerPage}
                    onChange={fetchData}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

const mapStateToProps = (state) => ({
  events: state.eventsReducer.events?.docs || [],
  pagination: state.eventsReducer.events || {},
  loading: state.eventsReducer.loading,
});

export default connect(mapStateToProps, null)(withTranslation()(ClientEvents));
